import React, { useRef, useState } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

interface HCaptchaWidgetProps {
  siteKey: string;
  onVerify: (token: string) => void;
  onExpire?: () => void;
  onError?: () => void;
}

export const HCaptchaWidget: React.FC<HCaptchaWidgetProps> = ({
  siteKey,
  onVerify,
  onExpire,
  onError,
}) => {
  const captchaRef = useRef<HCaptcha | null>(null);
  const [token, setToken] = useState<string | null>(null);

  const handleVerify = (token: string) => {
    setToken(token);
    onVerify(token);
  };

  const handleExpire = () => {
    setToken(null);
    onExpire?.();
  };

  const handleError = () => {
    setToken(null);
    onError?.();
  };

  return (
    <HCaptcha
      sitekey={siteKey}
      onVerify={handleVerify}
      onExpire={handleExpire}
      onError={handleError}
      ref={captchaRef}
    />
  );
};
